import { render, staticRenderFns } from "./Secret.vue?vue&type=template&id=624b744c&scoped=true"
import script from "./Secret.vue?vue&type=script&lang=js"
export * from "./Secret.vue?vue&type=script&lang=js"
import style0 from "./Secret.vue?vue&type=style&index=0&id=624b744c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624b744c",
  null
  
)

export default component.exports